import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './App.css';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Features from './components/Features';
import Architecture from './components/Architecture';
import ChainVisualizer from './components/ChainVisualizer';
import Tokenomics from './components/Tokenomics';
import DeveloperResources from './components/DeveloperResources';
import Roadmap from './components/Roadmap';
import Vision from './components/Vision';
import Community from './components/Community';
import Footer from './components/Footer';

function App() {
  const [activeSection, setActiveSection] = useState('hero');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['hero', 'features', 'architecture', 'tokenomics', 'developer', 'roadmap', 'vision', 'community'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="app" data-testid="app-container">
      <Navigation activeSection={activeSection} />
      <Hero />
      <Features />
      <Architecture />
      <ChainVisualizer />
      <Tokenomics />
      <DeveloperResources />
      <Roadmap />
      <Vision />
      <Community />
      <Footer />
    </div>
  );
}

export default App;
